var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69064 9.05936C6.8615 9.23021 7.1385 9.23021 7.30936 9.05936L10.8094 5.55936C10.9802 5.3885 10.9802 5.1115 10.8094 4.94064C10.6385 4.76979 10.3615 4.76979 10.1906 4.94064L7 8.13128L3.80936 4.94064C3.6385 4.76979 3.3615 4.76979 3.19064 4.94064C3.01979 5.1115 3.01979 5.3885 3.19064 5.55936L6.69064 9.05936Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.c65487459649965b82aa7b86e2d1ef4e.svg";
export { ForwardRef as ReactComponent };